module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDAgMjAwIj48cGF0aCBkPSJtMjguMiA1My42IDI1LjQtMTAuMy0xNC44LTIwLjdzLTItOC41IDYuMS0yUzY1LjggNDAgNjUuOCA0MHMzMC4zLTguMiA0NS44LTctMzUuNSAxNi43LTM1LjUgMTYuN2w1LjQgNi42UzYxLjQgNTUgNjMuNiA1Mi43YzIuMi0yLjQtMjcuNSA3LjQtMjcuNSA3LjRzLTkuMiA0LjMtMjIuNiAyYy00LS43IDMuNSAwIDQuNy00LjNzLTMuNS01LjMtMy41LTUuMy0zLjEtOC43IDYtNCA3LjUgNS4xIDcuNSA1LjF6IiBmaWxsPSIjQkVDRUNEIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/plane.svg
// module id = 111
// module chunks = 1